export default __webpack_public_path__ + "static/media/WebKorjaamo.f30e5999.png";